import { JoinData } from './JoinDataInt';

const menuButtonsHeight = 52;
const menuButtonsWidth = 154;

const menuButtonsY = 555;

const category = "room_video_roku";

const roomVideoRoku: JoinData[] = [
    { join: "digital-press-45", name: "Back", x: 133, y: 31, width: 53, height: 36, category },
    { join: "serial-feedback-2", name: "Room Name", x: 649, y: 22, width: 88, height: 32, category },

    { join: "digital-feedback-90", name: "Select Source Feedback", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "digital-press-90", name: "Select Source", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "serial-feedback-12", name: "Video Source Name", x: 969, y: 31, width: 159, height: 44, category },
    { join: "digital-press-122", name: "Video Power Off", x: 1225, y: 35, width: 30, height: 30, category },

    // { join: "svg_8", name: "Open Sharing Menu", x: 1211, y: 735, width: 45, height: 46, category },
    { join: "digital-feedback-91", name: "Video Mute Feedback", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-91", name: "Video Mute", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-95", name: "Video Volume Down", x: 644, y: 741, width: 39, height: 39, category },
    { join: "analog-feedback-1", name: "Current Volume", x: 707, y: 745, width: 25, height: 30, category },
    { join: "digital-press-94", name: "Video Volume Up", x: 753, y: 741, width: 39, height: 39, category },

    { join: "digital-press-302", name: "Down", x: 654, y: 430, width: 77, height: 35, category },
    { join: "digital-press-305", name: "Select", x: 630, y: 282, width: 124, height: 123, category },
    { join: "digital-press-303", name: "Left", x: 570, y: 305, width: 35, height: 77, category },
    { join: "digital-press-301", name: "Up", x: 654, y: 220, width: 77, height: 35, category },
    { join: "digital-press-304", name: "Right", x: 779, y: 305, width: 35, height: 77, category },

    { join: "digital-press-329", name: "Home", x: 201, y: menuButtonsY, width: menuButtonsWidth, height: menuButtonsHeight, category },
    { join: "digital-press-337", name: "Instant Replay", x: 358, y: menuButtonsY, width: menuButtonsWidth, height: menuButtonsHeight, category },

    { join: "digital-press-324", name: "Rewind", x: 597, y: 558, width: 45, height: 45, category },
    { join: "digital-press-321", name: "Play/Pause", x: 670, y: 558, width: 45, height: 45, category },
    { join: "digital-press-323", name: "Fast Forward", x: 745, y: 558, width: 45, height: 45, category },

    { join: "digital-press-326", name: "Back", x: 872, y: menuButtonsY, width: menuButtonsWidth, height: menuButtonsHeight, category },
    { join: "digital-press-330", name: "Guide", x: 1030, y: menuButtonsY, width: menuButtonsWidth, height: menuButtonsHeight, category },
];

export default roomVideoRoku;
